import React from "react";
import { Badge } from "../../../../components/ui/badge";
import { Card, CardContent } from "../../../../components/ui/card";

export const DivWrapperByAnima = ({ active }: { active: boolean }): JSX.Element => {
  const benefits = [
    "Keeps kids engaged for hours without screens",
    "Develops creativity and problem-solving skills",
    "Prevents travel meltdowns and boredom",
    "Gives parents a well-deserved break",
    "Creates fun travel memories",
    "Educational yet incredibly fun",
  ];

  return (
    <section
      id="benefits"
      className={`flex justify-center items-center bg-white mt-0 pt-20 pb-16 ${active ? "h-screen" : ""}`}
    >
      <div className="flex flex-wrap justify-center gap-16 max-w-screen-xl w-full">
        {/* Text & Badge Block */}
        <div className="flex flex-col items-center gap-8 lg:w-[624px]">
          <Badge
            variant="outline"
            className="px-4 py-2 rounded-[100px] border-[#169c79] opacity-[0.93]"
          >
            <span className="[font-family:'Plus_Jakarta_Sans',Helvetica] font-extrabold text-[#169C97] text-xs tracking-[0] leading-[16.8px]">
              HIGHLIGHTS
            </span>
          </Badge>

          <div className="flex flex-col items-center gap-4 w-full">
            <h2 className="[font-family:'Plus_Jakarta_Sans',Helvetica] font-bold text-[#1a1a1a] text-[40px] tracking-[0] leading-[60px] text-center">
              Turn &#34;Are We There Yet?&#34; Into &#34;Can We Stay Longer?&#34;
            </h2>
            <p className="[font-family:'Plus_Jakarta_Sans',Helvetica] font-normal text-[#595959] text-base tracking-[0] leading-6 text-center">
              Our Little Monsters Travel Kit transforms restless energy into creative focus, making travel time fly by for kids and giving parents peaceful moments to enjoy.
            </p>
          </div>
        </div>

        {/* Benefit Cards */}
        <div className="flex flex-col items-center gap-4 flex-1 pl-2">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex items-start gap-8 w-full">
              <div className="inline-flex flex-col items-center gap-4">
                <img
                  className="w-8 h-8"
                  alt={`Icon ${index + 1}`}
                  src={`/assets/${index + 1}.png`}
                />

                {index < benefits.length - 1 && (
                  <img
                    className="w-0.5 h-12"
                    alt="Divider"
                    src={`/assets/${index + 1}.png`}
                  />
                )}
              </div>

              <Card className="border-none shadow-none flex-1">
                <CardContent className="flex items-center p-1">
                  <p className="[font-family:'Plus_Jakarta_Sans',Helvetica] font-medium text-[#1a1a1a] text-base tracking-[0] leading-6">
                    {benefit}
                  </p>
                </CardContent>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
